

















import { Component, Vue } from 'vue-property-decorator'
import Vinyle from './Vinyle.vue'
import Pochette from './Pochette.vue'

@Component({
  components: { Vinyle, Pochette },
  props: {
    coverURL: String
  }
})
export default class VinylePochette extends Vue {
}
